export default {
  typography: {
    fontWeightRegular: 300,
    allVariants: {
      fontFamily: 'MuseoSans',
    },
    button: {
      textTransform: 'none',
      lineHeight: 'normal',
    },
  },
}
